import { atom } from "recoil";
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist({
    key: 'yancha-ls-persist', // this key is using to store data in local storage
    storage: localStorage, // configurate which stroage will be used to store the data
})

const _isloadinginitial = atom({
    key: '_isloadinginitial',
    default: true,
})

const _homepagedata = atom({
    key: '_homepagedata',
    default: {},
    effects_UNSTABLE: [persistAtom],
})

const _programlandingdata = atom({
    key: '_programlandingdata',
    default: {},
    effects_UNSTABLE: [persistAtom],
})

const _programid = atom({
    key: '_programid',
    default: Number,
    effects_UNSTABLE: [persistAtom],
})

const _initdata = atom({
    key: '_initdata',
    default: {},
    effects_UNSTABLE: [persistAtom],
})

const _quizdata = atom({
    key: '_quizdata',
    default: {},
    effects_UNSTABLE: [persistAtom],
})

const _question12Override = atom({
    key: 'questionverride',
    default: null
});

const _showstoryofliferesults = atom({
    key: '_storyofliferesults',
    default: '',
    effects_UNSTABLE: [persistAtom],
})

export { _isloadinginitial, _homepagedata, _programlandingdata, _programid, _initdata, _quizdata, _question12Override, _showstoryofliferesults }